import { CandidateProfileFormData } from 'features/profile/types';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ConnectedTextField } from 'shared/components';

export default function FieldFirstName() {
    const { control } = useFormContext<CandidateProfileFormData>();
    const { t } = useTranslation('profile');

    return (
        <ConnectedTextField
            control={ control }
            name="firstName"
            label={ t('fields.firstName') }
            required
        />
    );
}
